import {Component, ChangeDetectionStrategy} from '@angular/core';
import {InputComponent} from "../../../../shared-module/components/input/input.component";
import AbstractMyAccountDialogComponent from "../abstract-my-account-dialog.component";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ButtonComponent} from "../../../../shared-module/components/button/button.component";
import {ErrorDisplayComponent} from "../../../../shared-module/error-display/error-display.component";
import {
  PasswordValidationDisplayComponent
} from "../../../../shared-module/components/password-validation-display/password-validation-display.component";
import {containsNumberValidator} from "../../../../shared-module/validators/contains-number.validator";
import {containsUppercaseValidator} from "../../../../shared-module/validators/contains-uppercase.validator";
import {
  containsSpecialCharacterValidator
} from "../../../../shared-module/validators/contains-special-character.validator";
import {containsLowercaseValidator} from "../../../../shared-module/validators/contains-lowercase.validator";
import {matchesOtherControlValidator} from "../../../../shared-module/validators/matches-other-control.validator";
import {distinctUntilChanged} from "rxjs";

@Component({
    selector: 'app-edit-password-dialog',
  imports: [
    InputComponent,
    ButtonComponent,
    ErrorDisplayComponent,
    ReactiveFormsModule,
    PasswordValidationDisplayComponent
  ],
    templateUrl: './edit-password-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './edit-password-dialog.component.scss'
})
export class EditPasswordDialogComponent extends AbstractMyAccountDialogComponent {

  public successMessage: string = "Je wachtwoord is succesvol gewijzigd.";

  public form: FormGroup = new FormGroup({
    current_password: new FormControl("", [Validators.required]),
    password: new FormControl("", [Validators.required,
      containsNumberValidator,
      containsUppercaseValidator,
      containsSpecialCharacterValidator,
      containsLowercaseValidator,
      matchesOtherControlValidator('confirm_password'),
      Validators.minLength(8),
    ]),
    confirm_password: new FormControl("", [Validators.required, matchesOtherControlValidator('password')]),
  });

  constructor() {
    super();
    this.form.controls['password'].valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.form.controls['password'].updateValueAndValidity();
      this.form.controls['confirm_password'].updateValueAndValidity();
    });

    this.form.controls['confirm_password'].valueChanges.pipe(distinctUntilChanged()).subscribe(() => {
      this.form.controls['password'].updateValueAndValidity();
      this.form.controls['confirm_password'].updateValueAndValidity();
    });
  }
}
